import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jwtDecode  } from  'jwt-decode';
import { CookieService } from 'ngx-cookie-service';
import { Observable, catchError, map, take, throwError } from 'rxjs';
import { messageConstant } from 'src/app/shared/constant/message.constant';
import { PathConstant } from 'src/app/shared/constant/path.constant';
import { ISellerAll } from 'src/app/shared/model/seller.model';
import { AuthService } from 'src/app/shared/service/auth.service';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../service/error.service';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import { SweetAlert } from 'src/app/shared/alert/sweet-alert';
import { DataShareService } from 'src/app/core/service/data-share.service';

import * as moment from 'moment';
import { SessionStorageService } from '../service/session-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private userToken = '';
  private refreshToken = '';
  private decodedToken!: ISellerAll
  check = 1;
  messageConstant = '';
  confirmResumeToken: boolean = true;
  alertService: SweetAlert = new SweetAlert();

  constructor(
    private cookieService: CookieService,
    private errorService: ErrorService,
    private tokenService: TokenService,
    private authService: AuthService,
    private sessionStorageService: SessionStorageService,
    private router: Router,
    private dataShareService: DataShareService
  ) {
    // this.initialToken();
  }

  initialToken(): void {
    this.tokenService.getDataToken();
    if ( !this.cookieService.get('accessToken')) {
      // this.alertService.error("Please Login").then(()=>{
      //   this.router.navigate(['login']);

      // })
      // this.userToken =
      //   '';
      // this.refreshToken =
      //   '';
    } else {
      this.userToken = this.cookieService.get('accessToken');
      this.refreshToken = this.cookieService.get('refreshToken');
    }

  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const urlPath = request.url;
    this.userToken = this.cookieService.get('accessToken');
    this.refreshToken = this.cookieService.get('refreshToken');
    let transactionId = this.sessionStorageService.getItem('transactionId');
    if (!transactionId) {
      this.sessionStorageService.setItem('transactionId', moment().format('YYYYMMDDHHmmssSSS'));
      transactionId = this.sessionStorageService.getItem('transactionId');
    }
    const modifiedRequest = request.clone({
      setHeaders: {
        'x-authorization': `Bearer ${this.userToken}`,
        'x-api-request-id': transactionId,
      },
    });
    return next.handle(modifiedRequest).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log('error.message -->', error)
        var filterArray=['Invalid origDateFrom Format','Invalid origDateTo Format', "pathAPI is required", "MAC_ADDRESS is exists"]
        if (error.error.developerMessage === 'jwt expired') {
          this.alertService.error("Unauthorized: Access is denied due to invalid credentials.").then( async ()=>{
            document.getElementById('sign-out')?.click()
            // window.location.href = "/callback-signin"
          })
        } else if(error.error.developerMessage === 'Invalid Autherized Role' ||
          (error.error.errors.error === 'Unauthorized' && error.error.errors.statusCode === 401 && error.error.developerMessage !== 'invalid signature')
        ){
          // for Invalid Autherized Role and concurrence max user duplicate
          let replaceValue = error.error.developerMessage.replace(/\s/g, '<br/>');
          // need stop count Time
          this.dataShareService.sharingData.next({
            module: 'intercept',
            isError: true,
            text: replaceValue
          })

          this.alertService.error('',replaceValue).then((res)=>{
            document.getElementById('sign-out')?.click()
          })
        } else if(error.error.developerMessage === 'Invalid Duration Days'){
          this.alertService.error(error.error.developerMessage);
        } else if (error.error.developerMessage ==='Invalid Autherized Permission') {
          this.alertService.error('Invalid Autherized Permission');
        } else if(error.error.developerMessage ==="role is not allow empty"){
          this.alertService.error('role is not allow empty');
        } else if(error.error.developerMessage ==='channelType is not allow empty'){
          this.alertService.error('channelType is not allow empty');
        } else if(filterArray.includes(error.error.developerMessage)){
          this.alertService.error(error.error.developerMessage);
        } else if(error.error.developerMessage.toLowerCase().includes('resend error')){
          let replaceValue = error.error.developerMessage.replace(/\\"/g, '"');
          let json = JSON.parse(replaceValue.replace('Resend Error:',''));
          // console.log(' #### json -->', json)
          // this.alertService.error(json.errors[0].field + '\n' + json.errors[0].message);
          if (json.errors[0].field !== undefined && json.errors[0].message !== undefined) {
            this.alertService.error('',json.errors[0].field + '<br/>' + json.errors[0].message); // messge html
          } else {
            this.alertService.error('Resend Order Failed')
          }
        } else if (error.error.developerMessage === 'invalid signature') {
          this.alertService.error(error.error.developerMessage).then( async ()=>{
            window.location.href = "/callback-signin"
          })
        }
        else {
          this.alertService.error(error.message)
        }

        setTimeout(()=>{
          document.querySelectorAll('.backdrop').forEach((item) =>{
            item.classList.remove('backdrop')
          } );
          document.querySelectorAll('.spinner-three-bounce').forEach((item) =>{
            item.classList.remove('spinner-three-bounce')
          } );
        },200)

        // throw new Error(error.message);
        return throwError(() => error);

      }),
    );
  }

}
